'use client';

import { useState, useEffect } from 'react';

export function useBackButtonLoader() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handlePopState = () => {
      setIsLoading(true);
      // Simulate some asynchronous operation
      setTimeout(() => {
        setIsLoading(false);
      }, 1000); // Adjust this timeout as needed
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return isLoading;
}
